<bit-simple-dialog>
  <i bitDialogIcon class="bwi tw-text-3xl" [class]="iconClasses" aria-hidden="true"></i>

  <span bitDialogTitle>{{ title }}</span>

  <div bitDialogContent>{{ content }}</div>

  <ng-container bitDialogFooter>
    <button
      type="button"
      bitButton
      buttonType="primary"
      (click)="dialogRef.close(SimpleDialogCloseType.ACCEPT)"
    >
      {{ acceptButtonText }}
    </button>

    <button
      *ngIf="showCancelButton"
      type="button"
      bitButton
      buttonType="secondary"
      (click)="dialogRef.close(SimpleDialogCloseType.CANCEL)"
    >
      {{ cancelButtonText }}
    </button>
  </ng-container>
</bit-simple-dialog>
